import React from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import './App.css';
import AppRoutes from './routes';

function App() {
  return (
    <Router>
      <div className="App">
        <main className="App-main">
          <AppRoutes />
        </main>
      </div>
    </Router>
  );
}

export default App;
